export * from './partnerContent.service';
import { PartnerContentService } from './partnerContent.service';
export * from './partners.service';
import { PartnersService } from './partners.service';
export const APIS = [PartnerContentService, PartnersService];
